import { Button, Col, Row, Tooltip } from "antd";
import React, { useState } from "react";
import SearchControl from "../../../../../components/SearchControls/SearchGroups/SearchControl";
import { getIconUrl } from "../../../../../services/asset";
import styles from "./style.scss";
import { ControlType } from "../../../../../models";

const MobileModuleSearchGroup = props => {
  const {
    groupConfig,
    form,
    onSubmit,
    onReset,
    isMobile,
    renderCategorySelector,
    showAllControls,
    hideSearchButton
  } = props;

  const handleSubmit = () => {
    const { onSubmit } = props;

    onSubmit();
  };

  const renderSearchBtn = onClick => {
    return (
      <Button
        type="primary"
        className={`uppercase ${styles.searchButton}`}
        onClick={onClick}
      >
        <img
          alt={"Traži"}
          src={getIconUrl("search-white.svg")}
        />
        {"Traži"}
      </Button>
    );
  };

  return (
    <React.Fragment>
      <Row style={{ width: "100%" }}>
        <Row type="flex" gutter={24}>
          <Col span={24} style={{ marginBottom: "10px" }}>
            {renderCategorySelector()}
          </Col>
          {groupConfig.controls.map((controlConfig, index) => (
            <Col
              key={index}
              span={24}
              className={styles.column}
            >
              <SearchControl
                form={form}
                controlConfig={controlConfig}
                isMobile={isMobile}
                onSubmit={onSubmit}
                showPlaceholder={true}
                showAllControls={showAllControls}
              />
            </Col>
          ))}
          {!showAllControls && !hideSearchButton && (
            <Col span={24} className={styles.searchBtnCol}>
              {onReset && (
                <Tooltip title="Resetiraj filtere">
                  <span className={styles.resetBtn} onClick={onReset}>
                    <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
                  </span>
                </Tooltip>
              )}
              {renderSearchBtn(handleSubmit)}
            </Col>
          )}
        </Row>
      </Row>
    </React.Fragment>
  );
};

export default MobileModuleSearchGroup;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleSearchGroups/MobileModuleSearchGroup/index.tsx